// Storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  AUTH_USER: 'auth_user',
  ADMIN_NEWS: 'kxdex_admin_news',
  THEME_MODE: 'theme_mode',
} as const;

// Route paths
export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  MESSAGES: '/messages',
} as const;

// API paths
export const API = {
  AUTH_BASE: '/auth/api/v1',
  COMMON_BASE: '/api/v1/chain',
  SCENIC_BASE: '/api/v1/scenic',
  LOGIN: '/auth/api/v1/auth/login',
  REFRESH: '/auth/api/v1/auth/refresh',
  MESSAGES: '/auth/api/v1/messages',
  WALLETS: '/api/v1/chain/wallets',
  CONTRACTS: '/api/v1/chain/contracts',
  BLOCKCHAIN: '/api/v1/chain',
  BLOCKCHAIN_ANALYTICS: '/api/v1/chain/analytics',
  SYSTEM: '/api/v1/chain/system',
  EVENTS: '/api/v1/events',
} as const;

const normalizeApiPath = (path: string) => {
  if (!path) {
    return '';
  }
  return path.startsWith('/') ? path : `/${path}`;
};

export const buildCommonApiPath = (path: string) => {
  const normalized = normalizeApiPath(path);

  if (normalized.startsWith('/events')) {
    return `${API.EVENTS}${normalized.slice('/events'.length)}`;
  }

  if (normalized.startsWith('/contracts')) {
    return `${API.CONTRACTS}${normalized.slice('/contracts'.length)}`;
  }

  if (normalized.startsWith('/wallets')) {
    return `${API.WALLETS}${normalized.slice('/wallets'.length)}`;
  }

  if (normalized.startsWith('/system')) {
    return `${API.SYSTEM}${normalized.slice('/system'.length)}`;
  }

  if (normalized.startsWith('/blockchain/analytics')) {
    return `${API.BLOCKCHAIN_ANALYTICS}${normalized.slice('/blockchain/analytics'.length)}`;
  }

  if (normalized.startsWith('/blockchain')) {
    return `${API.BLOCKCHAIN}${normalized.slice('/blockchain'.length)}`;
  }

  return `${API.COMMON_BASE}${normalized}`;
};

export const buildAuthApiPath = (path: string) => `${API.AUTH_BASE}${normalizeApiPath(path)}`;

export const buildScenicApiPath = (path: string) => `${API.SCENIC_BASE}${normalizeApiPath(path)}`;

// Roles
export const ROLES = {
  ROOT: 'ROLE_ROOT',
  ADMIN: 'ROLE_ADMIN',
  BANK: 'ROLE_BANK',
  SCENIC: 'ROLE_SCENIC',
  EXCHANGE: 'ROLE_EXCHANGE',
  EXCHANGE_OPERATOR: 'ROLE_EXCHANGE_OPERATOR',
  MARKET_MAKER: 'ROLE_MARKET_MAKER',
  CONSUMER: 'ROLE_CONSUMER',
  REGULATOR: 'ROLE_REGULATOR',
} as const;
